"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vapi = exports.txt = exports.lds = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _graphqlRequest = require("graphql-request");
const waitForGlobal = function (key) {
  return new Promise(function (resolve) {
    const interval = setInterval(function () {
      if (window[key]) {
        resolve(window[key]);
        clearInterval(interval);
      }
    }, 250);
  });
};
const withWafTokenMiddleware = async function (request) {
  const AwsWafIntegration = await waitForGlobal("AwsWafIntegration");
  const token = await AwsWafIntegration.getToken().then(function (data) {
    return data;
  });
  if (!token) {
    return request;
  }
  return {
    ...request,
    headers: {
      ...request.headers,
      "X-Aws-Waf-Token": token
    }
  };
};
function createRequest(code, query) {
  const request = [`disclaimerCode: "${code}"`];
  const {
    dealerCd,
    distributorCd,
    modelYear,
    series
  } = query;
  if (dealerCd) {
    request.push(`dealerCd: "${dealerCd}"`);
  }
  if (distributorCd) {
    request.push(`distributorCd: "${distributorCd}"`);
  }
  if (modelYear) {
    request.push(`modelYear: ${modelYear}`);
  }
  if (series) {
    request.push(`series: "${series}"`);
  }
  return request;
}
const vapi = function (_ref) {
  let {
    code,
    query,
    endpoint
  } = _ref;
  const data = query;
  // "https://api.search-inventory.toyota.com/graphql"

  const client = new _graphqlRequest.GraphQLClient(endpoint, {
    headers: {},
    requestMiddleware: withWafTokenMiddleware
  });
  return client.request((0, _graphqlRequest.gql)`
      query {
        getDisclaimers(${createRequest(code, data)}) {
          description
          code
        }
      }
    `).then(function (_ref2) {
    let {
      getDisclaimers
    } = _ref2;
    return getDisclaimers === null || getDisclaimers === void 0 ? void 0 : getDisclaimers.description;
  });
};

// https://www.lexus.com/rest/lexus/disclaimers
exports.vapi = vapi;
const lds = function (_ref3) {
  let {
    code,
    endpoint
  } = _ref3;
  return (0, _axios.default)(`${endpoint}?code=${code}`).then(function (_ref4) {
    var _data$find;
    let {
      data
    } = _ref4;
    return (_data$find = data.find(function (i) {
      return i.code === code;
    })) === null || _data$find === void 0 ? void 0 : _data$find.disclaimer;
  });
};
exports.lds = lds;
const txt = function (_ref5) {
  let {
    code
  } = _ref5;
  return new Promise(function (resolve) {
    return resolve(code);
  });
};
exports.txt = txt;